<template>
  <div class="row my-4">
    <div class="col-md-6 mb-4" v-for="(product, i) in data" :key="i">
      <div class="store-grid-2" v-if="i < 2">
        <router-link
          :to="{
            name: 'list',
            query: { store: $route.query.store, category: product.category_id ,
                   name:product.category_name,   isFromStore:true},
                   params: {
                      menu_url_key: `store-${$route.query.store}`
                    }
          }"
        >
          <img :src="product.img_path" class="img-fluid" alt="" />
      <a v-if="id==1 && product.category_name.length > 2" href="#" class="grid-2-btn">
            {{ product.category_name }}
          </a>
          <h4 class="text-dark" v-else>   {{ product.category_name }}</h4>
        </router-link>
      </div>
    </div>
    <!-- <div class="col-md-6 store-grid-2">
          <div class="store-grid-2">
            <img src="/img/tFashionGrid2.jpg" class="img-fluid" alt="">
            <a href="#" class="grid-2-btn centerButton">
              Bags
            </a>
           </div>
        </div> -->
  </div>
</template>
<script>
export default {
  props: ["data",'id'],
};
</script>